fragment PackageFragment on Package {
  Code
  CountryCode
  Icon
  IsDeleted
  Name
  Description
}
